const defaultSetup = {
  myDashboard: {
    id: 'my-dashboard',
    path: 'my-dashboard/',
    description: 'My Dashboard',
  },
  questionBank: {
    id: 'question-bank',
    path: 'question-bank/',
    description: 'Question Bank',
  },
  workout: {
    id: 'workout',
    path: 'workout/',
    description: 'Workout',
  },
  selfAssessment: {
    numberOfQuestions: 10,
  },
}

// custom config will go here

export default {
  ...defaultSetup,
}



// WEBPACK FOOTER //
// ./src/module/setup.js